module.exports = require('./helpers/bundle-url').getBundleURL('9iXDo') + "IMG_0004.3a83e1b5.jpg" + "?" + Date.now();